<template>
  <useToast v-if="false" />
</template>

<script>
import { useToast } from 'vue-toastification';
export default {
  components: {
    useToast,
  },
  data() {
    return {};
  },
  setup() {
    // Get toast interface
    const toast = useToast();
    return { toast };
  },
  methods: {
    show(options) {
      if (!options) {
        options = { type: '' };
      }
      let title = options.title ? options.title : 'پیام';
      let opt = {
        position: options.position ? options.position : 'bottom-left',
        closeButton: 'button',
        icon: options.icon !== undefined ? options.icon : true,
        rtl: options.rtl !== undefined ? options.rtl : true,
        transition: 'Vue-Toastification__fade',
      };
      switch (options.type) {
        case 'success':
          this.toast.success(title, opt);
          break;
        case 'info':
          this.toast.info(title, opt);
          break;
        case 'warning':
          this.toast.warning(title, opt);
          break;
        case 'error':
          this.toast.error(title, opt);
          break;

        default:
          this.toast(title, opt);
          break;
      }
    },
  },
};
</script>
<style>
.Vue-Toastification__toast {
  font-family: 'vazir' !important;
  /* اندازه فونت آیکون */
  font-size: 20px !important;
  /* برای wrap شدن */
  word-break: break-word !important;
  overflow: auto !important;
  /* اندازه طول نوتی */
  min-width: 21.5rem !important;
  max-width: 21.5rem !important;
}
.Vue-Toastification__container {
  /*  برای فاصله از کنار صفحه نمایش */
  width: 22rem !important;
}
.Vue-Toastification__toast-body {
  /* فونت متن نوشتاری */
  font-size: 14px !important;
  /* برای فاصله بالا و پایین نوتی */
  white-space: normal !important;
  /* برای فاصله بین خط های متن */
  line-height: 30px !important;
}
</style>
